import easyfyAxios from '@shared/easyfy.axios';

export interface ICountryPopupRequest {
  country: string;
  site: string;
}

export const GetCountryPopupModal = async (data: ICountryPopupRequest): Promise<any> => {
  return await easyfyAxios.get(`/api/countrypopup?country=${data.country}&site=${data.site}`);
};
